<template>
  <div class="app-container" id="analysis">
    <mock-header :title="courseName" v-if="!isPrint"/>
    <div class="main container">
      <el-row :gutter="24">
        <el-col v-if="!isPrint" :span="5" style="min-height: 100%" class="goBackBtn">
          <router-link :to="{name: 'examSystem', query: {siteCourseID, courseID}}">返回系统管理目录</router-link>
        </el-col>
        <el-col v-if="!isPrint" :span="19" style="min-height: 100%; overflow: hidden">
          <common-breadcrumb
            @changeFontSize="changeFontSize"
            @handlePrint="handlePrint"
            :exam-name="commonInfo.examName"
            :courseID="courseID"
            :isShowToolbar="!isPrint"
            :siteCourseID="siteCourseID"/>
        </el-col>
      </el-row>
      <el-row :gutter="24" style="height:100%;">
        <el-col :span="5" style="min-height: 100%" v-if="!isPrint">
          <div class="left-main" :style="{position: isFixed}">
            <div class="left-title">
              <h2 v-if="mistake">错题解析</h2>
              <h2 v-else>答案解析</h2>
            </div>
            <div class="left-content">
              <div :class="item.isShow ? 'flnr' : 'flnr flnr-hidden'" v-for="(item, index) in quesTypeShowMap"
                   :key="index">
                <template v-if="item.lists.length">
                  <div class="left-content-title on" @click="slide(index)">
                    <h3>{{ item.viewTypeName }}(
                      <span>{{ item.lists && item.lists.length }}</span>题)
                    </h3>
                  </div>
                  <div :style="tabShowHeight(item)" class="jx_lcen">
                    <template v-for="(ans, index2) in item.lists">
                      <template v-if="ans.smallContent === undefined">
                        <ul style="padding-top: 2px; padding-bottom: 2px;" :key="index2 + 'a'">
                          <a href="javascript:void(0)" @click="goAnchor('#question_'+ ans.questionID)">
                            <li class="do" v-if="isAnswer(ans.userAnswer)">
                              <span>{{ index2 + 1 }}</span>已做
                            </li>
                            <li class="undo" v-else>
                              <span>{{ index2 + 1 }}</span>未做
                            </li>
                          </a>
                        </ul>
                      </template>
                      <template v-if="ans.smallContent !== undefined">
                        <ul v-for="(smallQues, index3) in ans.smallContent" :key="smallQues.questionID"
                            style="padding-top: 2px; padding-bottom: 2px;">
                          <a href="javascript:void(0)" @click="goAnchor('#question_'+ smallQues.questionID)" :key="index3 + 'b'">
                            <li class="do" v-if="isAnswer(smallQues.userAnswer)">
                              <span>{{`${index2+1}-${index3+1}`}}</span>已做
                            </li>
                            <li class="undo" v-else>
                              <span>{{`${index2+1}-${index3+1}`}}</span>未做
                            </li>
                          </a>
                        </ul>
                      </template>
                    </template>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="19" style="min-height: 100%;overflow: auto">
          <div class="right-main" :style="isPrint ? `width: 980px;` : `width: 100%;`">
            <div class="right-title-bg">
              <p style="float: right;"><img src="@/assets/images/Analysis/ct_titr.jpg"></p>
              <p><img src="@/assets/images/Analysis/ct_titl.jpg"></p>
              <p class="right-title">{{ commonInfo.examName }} ——答案解析</p>
            </div>
            <div :style="'font-size:' + mainSize" class="right-content" v-loading.fullscreen.lock="isLoading">
              <p class="right-content-explain">
                <strong class="fl">说明：</strong>
                <!-- 1.本试卷答题开始时间为{{ commonInfo.createTime }}，答题结束时间为{{ endTime }}，共用时
                <span style="color: red;">{{ secondsToMinutes }}</span>。 -->
                1.本试卷答题开始时间为{{ endTime }}，答题结束时间为{{ commonInfo.createTime }}，共用时
                <span style="color: red;">{{ secondsToMinutes }}</span>
                <br>
                2.自动判卷只能判断客观题。
              </p>
              <div class="right-content-table">
                <table cellSpacing="0" cellPadding="0">
                  <tbody>
                  <tr>
                    <th>题&nbsp;型</th>
                    <th>题目数量</th>
                    <th>答对题数</th>
                    <th>总&nbsp;分</th>
                    <th>得&nbsp;分</th>
                  </tr>
                  <tr v-for="(elem, index) in analyStatistics.quesTypeResultList" :key="index + 'c'">
                    <template v-if="elem.quesNum">
                      <td>{{ elem.viewTypeName }}</td>
                      <td>
                        <span>{{ elem.quesNum }}</span>
                        <span v-if="elem.smallQuesNum !== 0">（小题{{ elem.smallQuesNum }}道）</span>
                      </td>
                      <td>{{ elem.rightQuesNum }}</td>
                      <td>{{ elem.score }}</td>
                      <td>{{ elem.userScore }}</td>
                    </template>
                  </tr>
                  <tr>
                    <td colSpan="6">本次考试共{{ analyStatistics.allQuesNum }}道题 （小题共
                      <span id="xiaoNum">{{ analyStatistics.allSmallQuesNum }}</span>
                      道） ，总分{{ analyStatistics.allScore }}分，您做对{{ analyStatistics.allRightQuesNum }}道客观题，总得分
                      <span style="color: red;">{{ analyStatistics.allUserScore }}</span>分。
                    </td>
                  </tr>
                  </tbody>
                </table>
                <div class="right-content-qusetion">
                  <div v-for="(elem, index1) in quesTypeShowMap" :key="index1 + 'd'">
                    <template v-if="elem.lists.length">
                      <div class="right-content-qusetion-title">{{ elem.showSerialNum }}、{{ elem.viewTypeName }}</div>
                      <div v-for="(ans, index2) in elem.lists" :key="index2 + 'e'">
                        <template v-if="ans.smallContent === undefined">
                          <div class="right-content-question-main">
                            <a href="javascript:void(0)" :id="'question_'+ans.questionID" v-html="(index2 + 1) + '、' + ans.content"/>
                          </div>
                          <p v-for="(option, index3) in ans.optionList" :key="index3 + 'f'">
                            <strong>{{ option.quesValue }}、&nbsp;</strong>
                            <span v-html="option.quesOption"></span>
                          </p>
                          <div class="right-content-question-answer">
                            <span style="color: rgb(6, 88, 224);">{{ ans.userAnswer ? `您的答案：${ans.userAnswer}` : `您未做该题` }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <span style="color: rgb(255, 0, 0);"
                                  v-html="`正确答案：${ans.answer}&nbsp;&nbsp;&nbsp;&nbsp;得&nbsp;分：${ans.userScore === null ? 0 : ans.userScore}&nbsp;&nbsp;分`"></span>
                            <br>
                          </div>
                          <div class="right-content-question-analsis">
                            <strong>解析：</strong>
                            <span v-html="ans.analysis"/>
                          </div>
                          <div class="right-content-question-answer">
                            <template v-if="flag !== 'activity'">
                              <div class="collect" @click="quiz(ans.questionID)">【答疑编号{{ ans.questionID }}，点击提问】</div>
                              <div class="collect collect_last"
                                   @click="collectQues(ans.questionID, ans.chapterID)">【加入题库收藏夹】
                              </div>
                            </template>
                          </div>
                        </template>
                        <template v-else>
                          <div class="right-content-question-main">
                            <a href="javascript:void(0)" :id="ans.questionID" v-html="(index2 + 1) + '、' + ans.content"></a>
                          </div>
                          <template v-for="(smallQues, index3) in ans.smallContent">
                            <div class="right-content-question-main" :key="index3 + 'g'">
                              <a href="javascript:void(0)" :id="'question_'+smallQues.questionID"
                                 v-html="'<' + (index3 + 1) + '>、' + smallQues.content"></a>
                            </div>
                            <p v-for="(option, index4) in smallQues.optionList" :key="index3 + 'h' + index4">
                              <strong>{{ option.quesValue }}、&nbsp;</strong><span v-html="option.quesOption"/>
                            </p>
                            <template v-if="smallQues.quesTypeID === 4 || smallQues.quesTypeID === 5">
                              <div class="right-content-question-answer" :key="index3 + 'i'">
                                <div style="color: rgb(6, 88, 224);"
                                     v-html="smallQues.userAnswer ? `您的答案：<div>${smallQues.userAnswer}</div>` : `您未做该题`"></div>
                                <div style="color: rgb(255, 0, 0);" v-html="`正确答案：${smallQues.answer}`"></div>
                                <div style="color: rgb(0, 255, 255);"
                                     v-html="`得&nbsp;分：${smallQues.userScore === null ? 0 : smallQues.userScore}&nbsp;&nbsp;分`"></div>
                                <br>
                              </div>
                            </template>
                            <template v-else>
                              <div
                                class="right-content-question-answer"
                                :key="index3 + 'k'">
                                <span
                                  style="color: rgb(6, 88, 224);">{{ smallQues.userAnswer ? `您的答案：${smallQues.userAnswer}` : `您未做该题` }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <span
                                  style="color: rgb(255, 0, 0);"
                                  v-html="`正确答案：${smallQues.answer}&nbsp;&nbsp;&nbsp;&nbsp;得&nbsp;分：${smallQues.userScore === null ? 0 : smallQues.userScore}&nbsp;&nbsp;分`"></span>
                                <br>
                              </div>
                            </template>
                            <div
                              class="right-content-question-analsis"
                              :key="index3 + 'j'">
                              <strong>解析：</strong>
                              <span v-html="smallQues.analysis"/>
                            </div>
                            <template v-if="smallQues.quesTypeID === 4 || smallQues.quesTypeID === 5">
                              <div class="right-content-question-answer" :key="index3 + 'l'">
                                <template v-if="flag !== 'activity'">
                                  <div class="collect" @click=" quiz(smallQues.questionID)">【答疑编号{{ smallQues.questionID
                                    }}，点击提问】
                                  </div>
                                  <div class="collect collect_last"
                                       @click="collectQues(smallQues.questionID, smallQues.chapterID, ans.questionID)">
                                    【加入题库收藏夹】
                                  </div>
                                </template>
                              </div>
                            </template>
                            <template v-else>
                              <div
                                class="right-content-question-answer"
                                :key="index3 + 'm'">
                                <template v-if="flag !== 'activity'">
                                  <div
                                    class="collect"
                                    @click=" quiz(smallQues.questionID)">【答疑编号{{ smallQues.questionID }}，点击提问】
                                  </div>
                                  <div
                                    class="collect collect_last"
                                    @click="collectQues(smallQues.questionID, smallQues.chapterID, ans.questionID)">
                                    【加入题库收藏夹】
                                  </div>
                                </template>
                                <br>
                              </div>
                            </template>
                          </template>
                        </template>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="floatTips">
      <a href="javascript:scrollTo(0,0);"><font color="#000000">返回顶部</font></a>
    </div>
    <common-footer/>
  </div>
</template>

<script>
  import { MockHeader, CommonFooter, CommonBreadcrumb } from '@components/common'
  import { getCookie, setPageTitle, timestampToTime } from "@/utils"

  import { quesAnaly, addFavoriteQues } from '@api'

  export default {
    name: "analysis",
    components: {
      MockHeader,
      CommonBreadcrumb,
      CommonFooter
    },
    data() {
      return {
        courseID: '',
        siteCourseID: 0,
        bizID: '',
        flag: '',
        courseName: '',
        loadingInstance: null,
        quesShowList: {},
        userAnsMap: {},
        quesTypeShowMap: {},
        commonInfo: {},
        mistake: '',
        isFixed: 'relative',
        analyStatistics: {}, // 总的说明表格
        isPrint: false,
        isLoading: true,
        mainSize: '13px',
        wrongQuesList: [],  //  错题列表
        endTime:'',
        secondsToMinutes:''
      }
    },
    created() {
      this.init()
    },
    methods: {
      //锚点跳转
      goAnchor(selector) {
        this.$nextTick(() => {
          this.$el.querySelector(selector).scrollIntoView();
        })
      },
      // 获取答题结束时间
      endTimeFun() {
        //处理ie兼容
        let tempTime;
        let createTime;
        try {
          tempTime = this.commonInfo.createTime.replace(/-/g,'/')
          createTime = new Date(tempTime).getTime()
        } catch (error) {
          createTime = this.commonInfo.createTime
          // 将答题结束时间格式化
          this.commonInfo.createTime = timestampToTime(this.commonInfo.createTime)
        }
        let spendTime = this.commonInfo.spendTime * 1000
        let date = new Date(createTime - spendTime)
        let Y = date.getFullYear() + '-'
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
        let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' '
        let h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':'
        let m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ':'
        let s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds())
        return this.endTime = (Y + M + D + h + m + s)
      },
      // 更改花费时间格式
      secondsToMinutesFun() {
        let spendTime = this.commonInfo.spendTime
        let minutes = Math.floor(spendTime / 60)
        let seconds = spendTime % 60
        let minutesString = minutes > 9 ? minutes.toString() : '0' + minutes
        let secondString = seconds > 9 ? seconds.toString() : '0' + seconds
        return this.secondsToMinutes = minutesString + '分' + secondString + '秒'
      },
      async init() {
        const { majorID, flag } = this.$categoryInfo
        const { siteCourseID, courseID, bizID, mistake } = this.$route.query
        this.siteCourseID = parseInt(siteCourseID)
        this.courseID = parseInt(courseID)
        this.bizID = parseInt(bizID)
        this.majorID = majorID
        this.flag = flag
        this.mistake = parseInt(mistake)
        this.courseName = getCookie('courseName') || ''
        document.title = setPageTitle(this.courseName)
        await this.quesAnalyFun()
        await this.endTimeFun()
        await this.secondsToMinutesFun()
        await this.getWrongData()
        await this.questionsMap()
        await this.recombinateData()
        const that = this
        setTimeout(() => {
          that.isLoading = false
        },800)
      },
      //  获取查看解析数据
      async quesAnalyFun() {
        let params = {
          flag: this.flag,
          bizID: this.bizID
        }
        await this.$store.dispatch('getQuesAnaly', params).then(async(res) => {
          this.quesShowList = res.quesShowList
          this.userAnsMap = res.userAnsMap
          this.quesTypeShowMap = res.quesTypeShowMap
          this.commonInfo = res.commonInfo
          this.quesTypeOrder = res.quesTypeOrder
          await this.questionsMap()
          await this.recombinateData()
        }).catch(err => {
          this.$message.error(err.msg)
        })
      },
      //  遍历题型
      questionsMap() {
        let questionsArr = this.mistake ? this.wrongQuesList : this.quesShowList // 判断循环数组
        for (let quesType in this.quesTypeShowMap) {
          this.quesTypeShowMap[quesType].lists = [] // 题目list
          this.quesTypeShowMap[quesType].isShow = true // 菜单显示状态
          // 遍历questionsArr
          for (let i = 0; i < questionsArr.length; i++) {
            let item = questionsArr[i]
            let itemChilds = item.childQuesIDs
            if (this.quesTypeShowMap[quesType].relOrder === item.relOrder) {
              if (itemChilds && itemChilds !== 'mixed') { // 判断 是否属于大题套小题
                let itemChildsArr = itemChilds.split(',')
                let smallContent = []
                for (let smallID = 0; smallID < itemChildsArr.length; smallID++) {
                  smallContent.push(this.userAnsMap[itemChildsArr[smallID]])
                }
                this.userAnsMap[item.questionID].smallContent = smallContent
                this.quesTypeShowMap[quesType].lists.push(this.userAnsMap[item.questionID])
              } else {
                this.quesTypeShowMap[quesType].lists.push(this.userAnsMap[questionsArr[i].questionID])
              }
            }
          }
        }
      },
      //获取错题数据
      getWrongData() {  //  获取错题列表
        outermost: for (let i = 0; i < this.quesShowList.length; i++) {
          let item = this.quesShowList[i]
          let itemChilds = item.childQuesIDs
          if (itemChilds && itemChilds !== 'mixed') {
            let itemChildsArr = itemChilds.split(',')
            for (let smallID = 0; smallID < itemChildsArr.length; smallID++) {
              let index = itemChildsArr[smallID]
              if ((this.userAnsMap[index].answer !== this.userAnsMap[index].userAnswer) && (this.userAnsMap[index].userAnswer)) {
                this.wrongQuesList.push(item)
                continue outermost
              }
            }
          }
          if ((this.userAnsMap[item.questionID].answer !== this.userAnsMap[item.questionID].userAnswer) && (this.userAnsMap[item.questionID].userAnswer)) {
            this.wrongQuesList.push(item)
          }
        }
      },
      //重组quesTypeShowMap
      recombinateData() {
        // 总体数据的表格
        this.analyStatistics.quesTypeResultList = []
        this.analyStatistics.allQuesNum = 0
        this.analyStatistics.allSmallQuesNum = 0
        this.analyStatistics.allScore = 0
        this.analyStatistics.allUserScore = 0
        this.analyStatistics.allRightQuesNum = 0

        for (let i in this.quesTypeShowMap) {
          let quesType = this.quesTypeShowMap[i]
          let list = {}
          list.viewTypeName = quesType.viewTypeName
          list.quesNum = quesType.lists.length
          list.smallQuesNum = 0
          list.rightQuesNum = 0
          list.userScore = 0
          list.score = 0
          quesType.lists.forEach((question) => {
            if ((question.userScore !== 'mixed') && (!question.smallContent)) list.userScore += Number(question.userScore)
            if (!question.smallContent) list.score += question.score
            if ((question.userAnswer === question.answer) && (!question.smallContent)) list.rightQuesNum++
            if (question.smallContent) {
              list.smallQuesNum += question.smallContent.length
              question.smallContent.forEach(small => {
                list.score += small.score
                if (small.userScore !== 'mixed') list.userScore += Number(small.userScore)
                if (small.userAnswer === small.answer) list.rightQuesNum++
              })
            }
          })
          list.userScore = (list.userScore === null || list.userScore < 0) ? 0 : list.userScore
          this.analyStatistics.allRightQuesNum += list.rightQuesNum
          this.analyStatistics.allUserScore += list.userScore
          this.analyStatistics.allScore += list.score
          this.analyStatistics.allQuesNum += list.quesNum
          this.analyStatistics.allSmallQuesNum += list.smallQuesNum
          this.analyStatistics.quesTypeResultList.push(list)
          this.$forceUpdate()
        }
      },

      //  判断小题是否有答案
      isAnswer(value) {
        if (Array.isArray(value)) {
          return value.length
        } else if (value === null || value === '') {
          return false
        } else {
          return true
        }
      },
      changeFontSize(size) {
        this.mainSize = `${size}px`
      },
      handlePrint() {
        this.isPrint = true
        setTimeout(() => {
          window.print()
          this.isPrint = false
        }, 0)
      },
      //  隐藏左侧目录
      slide(idx) {
        this.quesTypeShowMap[idx].isShow = !this.quesTypeShowMap[idx].isShow
        this.$forceUpdate()
      },
      // 切换显示高度
      tabShowHeight(item) {
        if (item.isShow) {
          let height = 0
          item.lists.forEach(list => {
            if (list.smallContent) {
              height = height + (list.smallContent.length * 28)
            } else {
              height = height + 28
            }
          })
          return `height: ${height}px;`
        } else {
          return 'height: 0px;'
        }
      },
      //  到答疑板提问
      async quiz(questionID) {
        window.open('//member.chinaacc.com/faq/query.shtm?Forum_ID=' + this.siteCourseID + '&QNo=' + questionID)
      },
      //  收藏试题
      async collectQues(questionID, chapterID, parentID) {
        const questionIDParam = parentID ? parentID : questionID
        let collectQuesParams = {
          flag: this.flag,
          courseID: this.courseID,
          userID: parseInt(getCookie('cdeluid')),
          questionID: questionIDParam,
          chapterID,
        }
        await addFavoriteQues(collectQuesParams)
        .then(() => {
          this.$message({
            showClose: true,
            message: '题目收藏成功！',
            type: 'success'
          })
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  $bgUrl: '~@/assets/images';
  #analysis {
    .el-select-dropdown__item {
      text-align: center;
    }

    strong {
      vertical-align: top;
    }

    span {
      display: inline-block;
      max-width: 650px;
      white-space: normal;
    }

    .floatTips {
      border: solid 1px #FDD096;
      text-align: center;
      padding: 3px;
      position: fixed;
      bottom: 30px;
      right: 200px;
      width: 70px;
      color: #000;
      font-size: 13px;
      background: url($bgUrl + "/Analysis/hbtnbg.jpg") repeat-x #ACD6FF;
    }

    .left-main {
      position: relative;
      top: 0;
      width: 214px;
      border: 1px solid #9cd9ff;
      border-top: none;
      background-color: #fff;
    }

    .right-content {
      padding: 10px;
      font-size: 12px;
      border: 1px solid #a2dbff;
      background-color: rgb(255, 255, 255);
    }

    .right-title-bg {
      height: 33px;
      color: #034568;
      line-height: 33px;
      overflow: hidden;
      font-size: 12px;
      background: url($bgUrl + "/Analysis/ct_titbg.jpg") repeat-x;
    }

    .right-title-bg p {
      float: left;
    }

    .right-title {
      width: 90%;
      text-align: center;
      color: #04446b;
      line-height: 30px;
      font-size: 14px;
      font-weight: 600;
    }

    .right-content-explain {
      line-height: 24px;
      padding-top: 15px;
    }

    .right-content-explain strong {
      height: 30px;
      margin-right: 10px;
    }

    .right-content-table {
      margin-top: 10px;

      table {
        width: 100%;
        text-align: center;
        font-size: 12px;
        border-top: 1px solid #7fcdff;
        border-right: 1px solid #7fcdff;
        border-spacing: 0;

        th {
          height: 26px;
          color: #1c59b5;
          line-height: 26px;
          border-bottom: 1px solid #7fcdff;
          border-left: 1px solid #7fcdff;
          background-color: rgb(218, 239, 255);
        }

        td {
          height: 26px;
          color: #333333;
          line-height: 26px;
          border-bottom: 1px solid #7fcdff;
          border-left: 1px solid #7fcdff;
        }
      }
    }

    .right-content-qusetion {
      line-height: 22px;
      margin-top: 15px;
    }

    .left-title {
      height: 28px;
      background: url($bgUrl + "/Analysis/jx_titlebg1.jpg") repeat-x;

      h2 {
        text-align: left;
        color: #fff;
        line-height: 28px;
        padding-left: 85px;
        font-size: 14px;
        font-weight: 600;
        margin: 0 auto;
        background: url($bgUrl + "/Analysis/jx_xb1.jpg") no-repeat 50px 5px;
      }
    }

    .left-content {
      width: 214px;
      height: 500px;
      overflow-x: hidden;
      overflow-y: auto;

      ul {
        width: 130px;
        overflow: auto;
        padding: 10px;
        margin: 0 auto;

        li {
          height: 24px;
          line-height: 24px;
          padding-left: 25px;
          font-size: 14px;
          background: url($bgUrl + "/Analysis/jx_xb3.jpg") no-repeat 10px 6px;

          span {
            width: 30px;
            height: 20px;
            line-height: 24px;
            float: left;
            display: block;
          }
        }

        .do {
          color: #04446b;
        }

        .undo {
          color: #f5431f;

          span {
            color: #1878d6;
          }
        }
      }
    }

    .left-content-title {
      width: 183px;
      height: 30px;
      margin: 7px auto 0;
      background: url($bgUrl + "/Analysis/jx_btnn.jpg") no-repeat;
      overflow: hidden;

      h3 {
        height: 30px;
        color: #04446b;
        line-height: 30px;
        padding-left: 30px;
        font-size: 14px;
        font-weight: 600;
        background: url($bgUrl + "/Analysis/jx_nxb.jpg") no-repeat 10px 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .jx_btno {
      text-align: center;
      color: #f5431f;
      line-height: 24px;
      font-size: 12px;
      margin-top: 5px;
      margin-bottom: 5px;
      background-image: url($bgUrl + "/Analysis/leftbtn.jpg");
      background-attachment: scroll;
      background-repeat: no-repeat;
    }

    .right-content-qusetion-title {
      line-height: 30px;
      font-size: 16px;
      font-weight: 600;
    }

    .right-content-question-analsis {
      color: #057913;
    }

    .right-content-question-answer {
      // height: 45px;
      span {
        border: 0;
        margin-right: 10px;
      }

      div {
        color: rgb(6, 88, 224);
        cursor: pointer;
      }

      .collect {
        display: inline;
      }

      .collect_last {
        color: rgb(153, 0, 204);
      }
    }

    .right-content-question-main {
      text-indent: 0px;
      margin-top: 10px;

      .title-tmtit {
        display: flex;
        justify-content: space-between;
        width: 712px;
      }
    }

    .left-content .flnr .left-content-title {
      cursor: pointer;
    }

    .left-content .flnr .left-content-title h3 {
      background-image: url($bgUrl + "/Analysis/jx_nxb2.jpg");
      background-attachment: scroll;
      background-repeat: no-repeat;
      background-position-x: 10px;
      background-position-y: 8px;
    }

    .left-content .flnr .jx_lcen {
      overflow: hidden;
      transition: height 0.5s;
    }

    .left-content .flnr-hidden {
      .left-content-title h3 {
        background-image: url($bgUrl + "/Analysis/jx_nxb.jpg");
      }
    }

    @keyframes show-flnr {
      from {
        height: 0;
      }
      to {
        height: 200px;
      }
    }
    @keyframes hidden-flnr {
      from {
        height: 200px;
      }
      to {
        height: 0;
      }
    }

    .select-button {
      width: 100px;
    }

    .el-select {
      margin-bottom: 5px;
      width: 216px;
      height: 24px;

      .el-input__inner {
        height: 24px;
        padding-left: 15px;
        font-size: 12px;
        text-align: center;
      }

      input::-webkit-input-placeholder {
        color: #333;
      }

      input::-moz-placeholder { /* Mozilla Firefox 19+ */
        color: #333;
      }

      input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
        color: #333;
      }

      input:-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #333;
      }

      .el-input__suffix {
        // height: 20px;
        .el-input__icon {
          line-height: 20px;
        }
      }
    }

    .content_title {
      h3 {
        height: 30px;
        color: #04446b;
        line-height: 30px;
        padding-left: 30px;
        font-size: 14px;
        font-weight: 600;
        background: url($bgUrl + "/Analysis/jx_nxb.jpg") no-repeat 10px 8px;
      }
    }

    .goBackBtn {
      margin-bottom: 20px;

      a {
        display: inline-block;
        width: 216px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        border: 1px solid #9cd9ff;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        background: #fff;
        cursor: pointer;
        color: #606266;
      }

      a:hover {
        background: #fefefe;
      }
    }
  }
</style>
